import React, { useState, lazy } from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
interface VideoTestimonialProps {
  youtubeId?: string;
  index: number;
}
export function VideoTestimonial({
  youtubeId,
  index
}: VideoTestimonialProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  // Sin video cargado todavía: mostramos el placeholder editable
  if (!youtubeId) {
    return <div className="relative aspect-video bg-brand-dark rounded-lg overflow-hidden border border-gray-800 group" data-id="element-121">
        <MediaPlaceholder type="video" text={`[Video Testimonio ${index + 1}]`} className="w-full h-full border-none rounded-none" data-id="element-122" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-123">
          <div className="w-12 h-8 bg-red-600 rounded-lg flex items-center justify-center opacity-80" data-id="element-124">
            <div className="w-0 h-0 border-t-4 border-t-transparent border-l-[6px] border-l-white border-b-4 border-b-transparent ml-1" data-id="element-125" />
          </div>
        </div>
      </div>;
  }
  if (isPlaying) {
    return <div className="relative aspect-video bg-black rounded-lg overflow-hidden border border-gray-800" data-id="element-126">
        <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`} title={`Video testimonio ${index + 1}`} allow="accelerated-sensors; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-127" />
      </div>;
  }
  return <button type="button" onClick={() => setIsPlaying(true)} aria-label={`Reproducir video testimonio ${index + 1}`} className="relative aspect-video w-full bg-black rounded-lg overflow-hidden border border-gray-800 group cursor-pointer hover:border-brand-orange transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange" data-id="element-128">
      <img src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`} alt={`Miniatura del video testimonio ${index + 1}`} className="w-full h-full object-cover" loading="lazy" data-id="element-129" />
      <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors" data-id="element-130" />
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-131">
        <div className="w-16 h-11 bg-red-600 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-132">
          <div className="w-0 h-0 border-t-[8px] border-t-transparent border-l-[14px] border-l-white border-b-[8px] border-b-transparent ml-1" data-id="element-133" />
        </div>
      </div>
    </button>;
}